import { Injectable } from '@angular/core';
import { TourService as CoreTourService } from 'ngx-ui-tour-core';
import type { IStepOption } from './step-option';

@Injectable()
export class Tour<T extends IStepOption = IStepOption> extends CoreTourService<T> {}
